// This file is generated by scripts/generate-client-constants.js.
// Do not edit manually; update services/constants.js or the generator instead.

export const ACTIVE_STRATEGY = 'adx-di'
export const ADX_DI_STRATEGY = 'adx-di'
export const BB_STRATEGY = 'bb'
export const BBRVOL_STRATEGY = 'bbrvol'

export const LIVE_TYPE = 'live'
export const PAPER_TYPE = 'paper'
export const BACK_REAL_TYPE = 'back-real'
export const BACK_MOCK_TYPE = 'back-mock'
export const ACTIVE_TYPE = 'back-mock'

export const PERCENTAGE_STRATEGY = 'percentage'
